import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CardSize } from 'types/components/common/Card.type';

interface Props {
    size?: CardSize;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    size: { default: CardSize.LARGE }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-container", `card-container--${__props.size}`])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})